export default class PickupError extends Error {
  // eslint-disable-next-line no-useless-constructor
  constructor(message?: string) {
    super(message);
    this.name = 'PickupError';
  }
}
